import events from '../../actions/event-names';
import Config from '../../config';
import { showError, showSuccess } from '../../utils';

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    questionnaireList: [],
    isDetailsFetched: false,
    questionnaireDetails: "",
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   LIST
    case `${events.GET_QUESTIONNAIRE_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.questionnaireList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_QUESTIONNAIRE_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            questionnaireList: [...state.questionnaireList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_QUESTIONNAIRE_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //   DETAILS
    case `${events.GET_QUESTIONNAIRE_DETAILS}_PENDING`: {
        return {
            ...state,
            questionnaireDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_QUESTIONNAIRE_DETAILS}_FULFILLED`: {
        return {
            ...state,
            questionnaireDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_QUESTIONNAIRE_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    //   DETAILS FETCH BG
    case `${events.GET_QUESTIONNAIRE_DETAILS_BG}_PENDING`: {
        return {
            ...state,
            isQuesDetailsFetchedBg: 'PENDING',
        };
    }
    case `${events.GET_QUESTIONNAIRE_DETAILS_BG}_FULFILLED`: {
        return {
            ...state,
            questionnaireDetails: action.payload.data,
            isQuesDetailsFetchedBg: 'FULFILLED',
        };
    }
    case `${events.GET_QUESTIONNAIRE_DETAILS_BG}_REJECTED`: {
        return {
            ...state,
            isQuesDetailsFetchedBg: 'REJECTED',
        };
    }

    //   ADD NEW QUESTIONNAIRE
    case `${events.ADD_NEW_QUESTIONNAIRE}_PENDING`: {
        return {
            ...state,
            isNewQuestionnaireAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_QUESTIONNAIRE}_FULFILLED`: {
        return {
            ...state,
            isNewQuestionnaireAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_QUESTIONNAIRE}_REJECTED`: {
        return {
            ...state,
            isNewQuestionnaireAdded: 'REJECTED',
        };
    }

    //  QUESTIONNAIRE DETAILS SAVE
    case `${events.SAVE_QUESTIONNAIRE_TRANSLATIONS}_PENDING`:
    case `${events.SAVE_QUESTIONNAIRE_DETAILS}_PENDING`: {
        return {
            ...state,
            saveQstnareDetails: 'PENDING',
        };
    }
    case `${events.SAVE_QUESTIONNAIRE_TRANSLATIONS}_FULFILLED`:
    case `${events.SAVE_QUESTIONNAIRE_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            saveQstnareDetails: 'FULFILLED',
        };
    }
    case `${events.SAVE_QUESTIONNAIRE_TRANSLATIONS}_REJECTED`:
    case `${events.SAVE_QUESTIONNAIRE_DETAILS}_REJECTED`: {
        return {
            ...state,
            saveQstnareDetails: 'REJECTED',
        };
    }

    //  CREATE QUESTIONNAIRE SECTION
    case `${events.CREATE_SECTION}_PENDING`: {
        return {
            ...state,
            isSectionCreated: 'PENDING',
        };
    }
    case `${events.CREATE_SECTION}_FULFILLED`: {
        showSuccess("New section created successfully")
        return {
            ...state,
            isSectionCreated: 'FULFILLED',
        };
    }
    case `${events.CREATE_SECTION}_REJECTED`: {
        return {
            ...state,
            isSectionCreated: 'REJECTED',
        };
    }

    //  DELETE QUESTIONNAIRE SECTION
    case `${events.DELETE_SECTION}_PENDING`: {
        return {
            ...state,
            isSectionDeleted: 'PENDING' + action.meta.secId,
        };
    }
    case `${events.DELETE_SECTION}_FULFILLED`: {
        showSuccess("Section deleted successfully")
        return {
            ...state,
            isSectionDeleted: 'FULFILLED' + action.meta.secId,
        };
    }
    case `${events.DELETE_SECTION}_REJECTED`: {
        return {
            ...state,
            isSectionDeleted: 'REJECTED' + action.meta.secId,
        };
    }

    //  UPDATE QUESTIONNAIRE SECTION
    case `${events.UPDATE_SECTION}_PENDING`: {
        return {
            ...state,
            isSectionUpdated: 'PENDING' + action.meta.secId,
        };
    }
    case `${events.UPDATE_SECTION}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isSectionUpdated: 'FULFILLED' + action.meta.secId,
        };
    }
    case `${events.UPDATE_SECTION}_REJECTED`: {
        return {
            ...state,
            isSectionUpdated: 'REJECTED' + action.meta.secId,
        };
    }

    //  UPDATE  SECTION QUESTION
    case `${events.UPDATE_SECTION_QUESTION}_PENDING`: {
        return {
            ...state,
            isQuestionUpdated: 'PENDING' + action.meta.questionId,
        };
    }
    case `${events.UPDATE_SECTION_QUESTION}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isQuestionUpdated: 'FULFILLED' + action.meta.questionId,
        };
    }
    case `${events.UPDATE_SECTION_QUESTION}_REJECTED`: {
        return {
            ...state,
            isQuestionUpdated: 'REJECTED' + action.meta.questionId,
        };
    }

    //  ADD  SECTION QUESTION
    case `${events.ADD_NEW_SEC_QUESTION}_PENDING`: {
        return {
            ...state,
            isNewQuestionAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_SEC_QUESTION}_FULFILLED`: {
        showSuccess("New question added successfully")
        return {
            ...state,
            isNewQuestionAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_SEC_QUESTION}_REJECTED`: {
        return {
            ...state,
            isNewQuestionAdded: 'REJECTED',
        };
    }

    //  DELETE QUESTION
    case `${events.DELETE_QUESTION}_PENDING`: {
        return {
            ...state,
            isQuestionDeleted: 'PENDING' + action.meta.questionId,
        };
    }
    case `${events.DELETE_QUESTION}_FULFILLED`: {
        showSuccess("Question deleted successfully")
        return {
            ...state,
            isQuestionDeleted: 'FULFILLED' + action.meta.questionId,
        };
    }
    case `${events.DELETE_QUESTION}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isQuestionDeleted: 'REJECTED' + action.meta.questionId,
        };
    }

    //  ADD NEW OPTION
    case `${events.ADD_NEW_OPTION}_PENDING`: {
        return {
            ...state,
            isNewOptionAdded: 'PENDING' + action.meta.questionId,
        };
    }
    case `${events.ADD_NEW_OPTION}_FULFILLED`: {
        showSuccess("New option added successfully")
        return {
            ...state,
            isNewOptionAdded: 'FULFILLED' + action.meta.questionId,
        };
    }
    case `${events.ADD_NEW_OPTION}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isNewOptionAdded: 'REJECTED' + action.meta.questionId,
        };
    }

    //  DELETE OPTION
    case `${events.DELETE_OPTION}_PENDING`: {
        return {
            ...state,
            isOptionDeleted: 'PENDING' + action.meta.optionId,
        };
    }
    case `${events.DELETE_OPTION}_FULFILLED`: {
        showSuccess("Option deleted successfully")
        return {
            ...state,
            isOptionDeleted: 'FULFILLED' + action.meta.optionId,
        };
    }
    case `${events.DELETE_OPTION}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isOptionDeleted: 'REJECTED' + action.meta.optionId,
        };
    }

    //  UPDATE OPTION
    case `${events.UPDATE_OPTION}_PENDING`: {
        return {
            ...state,
            isOptionUpdated: 'PENDING' + action.meta.optionId,
        };
    }
    case `${events.UPDATE_OPTION}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isOptionUpdated: 'FULFILLED' + action.meta.optionId,
        };
    }
    case `${events.UPDATE_OPTION}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isOptionUpdated: 'REJECTED' + action.meta.optionId,
        };
    }

    //  ACTIVATE QUESTIONNAIRE
    case `${events.ACTIVATE_QUESTIONNAIRE}_PENDING`: {
        return {
            ...state,
            isQuestionnaireActivated: 'PENDING',
        };
    }
    case `${events.ACTIVATE_QUESTIONNAIRE}_FULFILLED`: {
        showSuccess("Activated successfully")
        return {
            ...state,
            isQuestionnaireActivated: 'FULFILLED',
        };
    }
    case `${events.ACTIVATE_QUESTIONNAIRE}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isQuestionnaireActivated: 'REJECTED',
        };
    }



    


    default:
        return state;
    }
}
